import MuiCollapse, { CollapseProps as MuiCollapseProps } from '@mui/material/Collapse';
import * as React from 'react';

export interface CollapseProps extends MuiCollapseProps {}

export const Collapse = (props: CollapseProps) => {
  return <MuiCollapse {...props} />;
};
